import {
    DEFAULT_GEOMETRY,
    DEFAULT_ZOOM,
    _show_infoWindow,
} from './_setup';

const setup_user_maps = () => {
    const {OverlappingMarkerSpiderfier} = require('../../lib/oms.min.js');
    window.initMap = () => {
        const $map = $('#google-maps');
        if (!$map.length) return;

        const has_map_geometry = !!$map.data('geometry');
        const geometry = has_map_geometry ? $map.data('geometry') : DEFAULT_GEOMETRY;
        const zoom = has_map_geometry ? 16 : DEFAULT_ZOOM;
        const styles = $map.data('styles');

        const map = new google.maps.Map(document.querySelector('#google-maps'), {
            center: geometry.location,
            zoom: zoom,
            styles: styles,
        });

        const infowindow = new google.maps.InfoWindow();
        const infowindowContent = document.getElementById('google-maps-infowindow');
        infowindow.setContent(infowindowContent);

        const main_marker = has_map_geometry ? new google.maps.Marker({
            map: map,
            position: geometry['location'],
        }) : null;

        const google_map = window.google_map = {
            map,
            infowindow,
            infowindowContent,
            main_marker,
        };

        const has_marker_data = !!$map.data('markers') && $map.data('markers').length;
        if (has_marker_data) {
            const all_marker_data = $map.data('markers');
            const markers = all_marker_data.map((marker_data, i) => {
                return new google.maps.Marker({
                    map: map,
                    position: marker_data['location'],
                    title: marker_data['display_name'],
                    post_id: marker_data['id'],
                    address: marker_data['address'],
                    permalink: marker_data['permalink'],
                });
            });
            // if (main_marker) markers.push(main_marker);

            const oms = new OverlappingMarkerSpiderfier(map, {
                markersWontMove: true,
                markersWontHide: true,
                basicFormatEvents: true
            });

            const bounds = new google.maps.LatLngBounds();
            markers.forEach(marker => {
                bounds.extend(marker.position);
                oms.addMarker(marker);

                google.maps.event.addListener(marker, 'spider_click', (e) => {
                    _show_infoWindow(map, marker, infowindow, infowindowContent, marker.title, marker.address, marker.permalink);
                });
            });
            if (!!main_marker) bounds.extend(main_marker.position);
            map.fitBounds(bounds);

            google_map.markers = markers.reduce((map, marker) => {
                map[marker.post_id] = marker;
                return map;
            }, {});
        }
    };
};

export {
    setup_user_maps,
}
